var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83267 4.358C7.9219 4.24636 8.0351 4.15622 8.16389 4.09425C8.29267 4.03228 8.43375 4.00007 8.57667 4H31.4487C31.5916 4.00007 31.7327 4.03228 31.8615 4.09425C31.9902 4.15622 32.1034 4.24636 32.1927 4.358L39.8167 13.888C39.9582 14.065 40.032 14.2867 40.0249 14.5132C40.0177 14.7397 39.9301 14.9563 39.7777 15.124L20.7337 36.072C20.7167 36.091 20.6997 36.11 20.6807 36.128C20.5944 36.2133 20.4926 36.2812 20.3807 36.328L20.3437 36.342C20.1733 36.4042 19.9888 36.4165 19.8117 36.3775C19.6345 36.3386 19.4722 36.2499 19.3437 36.122C19.3277 36.106 19.3123 36.0897 19.2977 36.073L0.247668 15.124C0.0952623 14.9563 0.0076219 14.7397 0.000474401 14.5132C-0.0066731 14.2867 0.0671401 14.065 0.208668 13.888L7.83267 4.358ZM22.3997 31.41L36.9177 15.436H27.8417L22.3997 31.41ZM25.8317 15.436L20.0127 32.5L14.1997 15.436H25.8317ZM3.11067 15.436H12.1867L17.6287 31.41L3.11067 15.436ZM8.39067 6.711L2.93567 13.53H11.7997L8.39067 6.711ZM10.1187 5.906L13.4787 12.626L18.1787 5.906H10.1187ZM21.8427 5.906L26.5427 12.626L29.9027 5.906H21.8427ZM31.6347 6.711L28.2257 13.53H37.0897L31.6347 6.711ZM24.8527 13.53L20.0127 6.615L15.1717 13.53H24.8527Z",
    fill: "#0565A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.404a737b98616d9f484db6d1c0f1a580.svg";
export { ForwardRef as ReactComponent };